import React from 'react';
import styles from './CheckoutModal.module.scss';
import cx from 'classnames';

import Modal from '../../generic/Modal/Modal';
import CheckoutForm from '../CheckoutForm/CheckoutForm';

const CheckoutModal = ({lesson, babyConnect = false, ...props }) => {
  const [checkoutSection, setCheckoutSection] = React.useState('GEGEVENS');

  return (
    <Modal {...props}>
      <div className={cx(styles.poster, babyConnect && styles.baby)} />
      <CheckoutForm
        babyConnect={babyConnect}
        lesson={lesson}
        checkoutSection={checkoutSection}
        setCheckoutSection={setCheckoutSection}
      />
    </Modal>
  )
}

export default CheckoutModal;
